import { CustomField } from '@wix/bex-core';

export interface BaseInputProps<T> {
  dataHook?: string;
  schema: CustomField;
  initialValue: T;
  onChange: (newValue: T) => void;
  inputRef?: (ref: BaseInputRef) => void;
}

export interface BaseInputRef {
  focus?: () => void;
  invalid?: boolean;
}
